/**
 * FisicaOnboardingFlow (F1 plan Persona Moral).
 *
 * Adaptador delgado que envuelve los datos existentes de PF en
 * `onboardingFlow.ts` y los expone a través de la interfaz `OnboardingFlow`.
 *
 * Decisión F1 (aprobada): DELEGAR, no mover. `onboardingFlow.ts` sigue siendo
 * la única fuente de verdad de los steps/paths/mapeo; este flow solo los
 * adapta. Así PF queda byte-idéntico. Mover los datos adentro queda como
 * cleanup posterior.
 */
import type { OnboardingFlow, OnboardingFlowStep } from '@tankef/core';

import {
  ONBOARDING_STEPS_INDIVIDUAL,
  ONBOARDING_STEP_PATHS,
  mapBackendStepToFrontend,
  type OnboardingStepId,
} from '../routes/onboardingFlow';

/** Bloque BE al que pertenece cada step de PF. Los review steps FE-only
 * (data/address/curp/rfc) colapsan al bloque `kyc` (data_confirmation). */
const STEP_BLOCK: Record<OnboardingStepId, string> = {
  email: 'registration',
  email_verification: 'registration',
  phone: 'registration',
  phone_verification: 'registration',
  password: 'registration',
  location_and_camera: 'kyc',
  ine_capture: 'kyc',
  selfie: 'kyc',
  identity_result: 'kyc',
  data: 'kyc',
  address: 'kyc',
  curp: 'kyc',
  rfc: 'kyc',
  transactional_profile: 'profile',
  fiscal_document: 'profile',
  beneficiary: 'closing',
  contract: 'closing',
};

const steps: ReadonlyArray<OnboardingFlowStep> = ONBOARDING_STEPS_INDIVIDUAL.map(id => ({
  id,
  path: ONBOARDING_STEP_PATHS[id],
  i18nKey: `onboarding.${id}`,
  block: STEP_BLOCK[id] ?? 'unknown',
}));

const byId = new Map(steps.map(s => [s.id, s]));
const byPath = new Map(steps.map(s => [s.path, s]));

export const fisicaFlow: OnboardingFlow = {
  partyType: 'fisica',
  version: 'fisica_v1',
  steps,
  stepFor: stepId => byId.get(stepId) ?? null,
  stepForPath: path => byPath.get(path) ?? null,
  defaultOrder: () => ONBOARDING_STEPS_INDIVIDUAL,
  mapBackendStep: backend => mapBackendStepToFrontend(backend),
};
